import { Environment } from 'environment.js'
import { get } from 'Repository/index.js'
import type { Observable } from 'rxjs'
import type { PlanDTO } from '../../Generated/PlanDTO.ts'
import type { CreditItemDTO } from '../../Generated/CreditItemDTO.ts'
import type { CreditBalanceDTO } from '../../Generated/CreditBalanceDTO.ts'
import type { CreditTransactionDTO } from '../../Generated/CreditTransactionDTO.ts'

const base = `${Environment.API_URL}/v1/chargebee`

export const getPlans = (): Observable<PlanDTO[]> => get(`${base}/plans`, {})

export const getCreditItems = (): Observable<CreditItemDTO[]> => get(`${base}/credit-items`, {})

export const getCredits = (): Observable<CreditBalanceDTO> => get(`${base}/credits`, {})

export const getCreditHistory = (): Observable<CreditTransactionDTO[]> => get(`${base}/credits/history`, {})
